import React, { Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import { NumberFormat } from '../../utils/numberFormat'
import { extractCostTranslation } from '../../utils/translations.utils'

const styles = (theme) => ({
  body: {
    margin: 0,
    fontFamily: 'Arial, sans-serif',
    backgroundColor: 'white',
    padding: '50px',
    fontSize: 14,
    overflowX: 'auto',
    marginBottom: 10,
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px'
    }
  },
  header: {
    width: '100%',
    fontSize: 12,
    tableLayout: 'fixed',
    [theme.breakpoints.down('xs')]: {
      width: '68vh'
    }
  },
  headerCenterText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  floatR: {
    textAlign: 'right',
    fontSize: 16,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  invoiceInfoWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      width: '68vh'
    }
  },
  invoiceInfoLeft: {
    margin: '80px 0px 0px 50px'
  },
  invoiceInfoRight: {
    width: 332,
    padding: '5px 15px'
  },
  invoiceInfoRightRow: {},
  info: {
    margin: '0px 20px 0px 0px'
  },
  info2: {
    wordBreak: 'break-word',
    margin: '0px'
  },
  tdInfo: {
    verticalAlign: 'top'
  },
  invoiceItems: {
    margin: '30px 0 20px'
  },
  invoiceTableHeader: {
    fontWeight: 'bold',
    fontSize: 13,
    tableLayout: 'fixed',
    borderBottom: '1px solid black'
  },
  invoiceBuildingServiceInfo: {
    fontWeight: 'bold',
    fontSize: 13,
    tableLayout: 'fixed',
    padding: '8px 30px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '68vh',
      padding: 10
    }
  },
  paymentTableInfo: {
    fontWeight: 'bold',
    fontSize: 13,
    tableLayout: 'fixed',
    borderBottom: '1px solid black',
    padding: '8px 30px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '68vh',
      padding: 10
    }
  },
  paymentTableHeader: {
    fontWeight: 'bold',
    fontSize: 13,
    tableLayout: 'fixed',
    padding: '0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px'
    }
  },
  invoiceInputRow: {
    tableLayout: 'fixed',
    padding: '0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px'
    }
  },
  paymentTableRow: {
    padding: '0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px'
    }
  },
  bankInfo: {
    display: 'flex',
    padding: '8px 30px',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      padding: '8px 0px',
      width: '68vh'
    }
  },
  virtualCode: {
    padding: '0 30px',
    borderBottom: '1px solid black',
    [theme.breakpoints.down('xs')]: {
      width: '68vh',
      padding: 0
    }
  },
  paymentInfo: {
    fontSize: 12,
    //lineHeight: 12,
    textAlign: 'right',
    paddingRight: 24,
    marginTop: 10,
    marginBottom: 10
  },
  barcodeText: {
    fontWeight: 'normal',
    margin: '40px 30px',
    [theme.breakpoints.down('sm')]: {
      margin: 10
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 10,
    [theme.breakpoints.down('xs')]: {
      width: '68vh'
    }
  },
  borderBox: {
    borderBottom: '1px solid black',
    borderRight: '1px solid black',
    paddingLeft: 10
  },
  borderBottom: {
    borderBottom: '1px solid black',
    paddingLeft: 10
  },
  bankCodes: {
    fontSize: 12,
    margin: 0
  },
  logo: {
    maxWidth: '300px',
    maxHeight: '150px',
    [theme.breakpoints.down('992')]: {
      maxWidth: '200px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '150px'
    }
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'left'
  }
})

const invoicePdf = ({
  classes,
  invoice,
  userName,
  originalInvoiceId,
  logo,
  userType,
  userEmail
}) => {
  const invoiceLanguage = invoice?.invoice_lang === true ? 'En' : 'Fi'

  const getInvoicePdfLang = (language) => {
    return `invoicePdf${language}`
  }
  const invoicePdfKey = getInvoicePdfLang(invoiceLanguage)

  return (
    <Translation>
      {(t) => {
        return invoice?.rows?.length > 0 ? (
          <div className={classes.body}>
            <div>
              <table className={classes.header}>
                <tbody>
                  <tr>
                    <td>
                      <div className={classes.logoContainer}>
                        {!logo ? (
                          <p>
                            Invosy.com/fi-
                            {t(`${invoicePdfKey}.service_name`)}
                          </p>
                        ) : (
                          <img
                            className={classes.logo}
                            src={logo.path}
                            alt="logo.png"
                          />
                        )}
                      </div>
                    </td>
                    <td className={classes.headerCenterText}>
                      <p>
                        {originalInvoiceId && originalInvoiceId > 1
                          ? t(`${invoicePdfKey}.credit_note_from_invoice_no`) +
                            originalInvoiceId
                          : Number.parseFloat(
                              invoice.total_sum
                                .toString()
                                .replace(/−/g, '-')
                                .replace(/,/g, '.')
                            ) < 0
                          ? t(`${invoicePdfKey}.invoice_credit_note`)
                          : t(`${invoicePdfKey}.invoice`)}
                      </p>
                    </td>
                    <td className={classes.floatR}>
                      <p>
                        {new Intl.DateTimeFormat('fi-FI').format(
                          invoice.billing_date
                        )}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={classes.invoiceInfoWrapper}>
              <div className={classes.invoiceInfoLeft}>
                <p>{invoice.company_name}</p>
                <p>{invoice.person_to_contact}</p>
                <p>{invoice.delivery_address}</p>
                <p>
                  {invoice.zip_code} {invoice.city}
                </p>
              </div>
              <div className={classes.invoiceInfoRight}>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.number`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2} style={{ color: 'gray' }}>
                          XXXX
                        </p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.due_date1`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>
                          {new Intl.DateTimeFormat('fi-FI').format(
                            invoice.due_date
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.ref_number`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2} style={{ color: 'gray' }}>
                          XXXX
                        </p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.your_reference`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>
                          {invoice.invoice_reference}
                        </p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.our_reference`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>{invoice.description}</p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.seller`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>{userName}</p>
                      </td>
                    </tr>
                    {userType !== 3 ? (
                      <tr className={classes.invoiceInfoRightRow}>
                        <td className={classes.tdInfo}>
                          <p className={classes.info}>
                            {t(`${invoicePdfKey}.payer_email`)}
                          </p>
                        </td>
                        <td className={classes.tdInfo}>
                          <p className={classes.info2}>{userEmail}</p>
                        </td>
                      </tr>
                    ) : null}
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.interest_rate`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>7%</p>
                      </td>
                    </tr>
                    <tr className={classes.invoiceInfoRightRow}>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.payment_terms`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>
                          {invoice.overdue} {t(`${invoicePdfKey}.day_net`)}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className={classes.tdInfo}>
                        <p className={classes.info}>
                          {t(`${invoicePdfKey}.notice_period`)}
                        </p>
                      </td>
                      <td className={classes.tdInfo}>
                        <p className={classes.info2}>
                          7 {t(`${invoicePdfKey}.notice_period_days`)}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className={classes.invoiceItems}>
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr className={classes.invoiceTableHeader}>
                    <td
                      style={{ width: '276px' }}
                      className={classes.paymentTableHeader}
                    >
                      <p>{t(`${invoicePdfKey}.services`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.amount`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.unit_price`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.vat_percentage`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.vat_zero_percentage`)} €</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.tax`)} €</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.total`)} €</p>
                    </td>
                  </tr>
                  <tr style={{ height: 10 }}></tr>
                  {invoice.rows.map((invoiceRow, index) => {
                    return (
                      <Fragment key={index}>
                        <tr>
                          <td
                            style={{ width: 276 }}
                            className={classes.invoiceInputRow}
                          >
                            <p>
                              {extractCostTranslation(
                                t,
                                invoiceRow.description,
                                invoice?.invoice_lang
                              )}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{ width: 276 }}
                            className={classes.invoiceInputRow}
                          >
                            <p>
                              {t(`${invoicePdfKey}.period`) +
                                ' ' +
                                new Intl.DateTimeFormat('fi-FI').format(
                                  invoiceRow.start_date
                                ) +
                                ' - ' +
                                new Intl.DateTimeFormat('fi-FI').format(
                                  invoiceRow.end_date
                                )}
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              <NumberFormat value={invoiceRow.quantity} />
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              <NumberFormat value={invoiceRow.quantity_price} />
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              {invoiceRow.vat_percent
                                .toString()
                                .replace('.', ',')}
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              <NumberFormat value={invoiceRow.sum_tax_free} />
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              <NumberFormat value={invoiceRow.vat} />
                            </p>
                          </td>
                          <td className={classes.invoiceInputRow}>
                            <p>
                              <NumberFormat value={invoiceRow.sum_with_vat} />
                            </p>
                          </td>
                        </tr>
                      </Fragment>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div>
              {invoice.vat_selection === 'building_service' ? (
                <p className={classes.invoiceBuildingServiceInfo}>
                  {t(`${invoicePdfKey}.building_service`)}
                </p>
              ) : null}

              <p className={classes.paymentTableInfo}>
                {t(`${invoicePdfKey}.note`)}.
              </p>

              <table className={classes.paymentTableInfo}>
                <tbody style={{ textAlign: 'center' }}>
                  <tr>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.due_date1`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.vat_zero`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.vat`)}</p>
                    </td>
                    <td className={classes.paymentTableHeader}>
                      <p>{t(`${invoicePdfKey}.total_eur`)}</p>
                    </td>
                  </tr>
                  <tr>
                    <td className={classes.paymentTableRow}>
                      <p>
                        {new Intl.DateTimeFormat('fi-FI').format(
                          invoice.due_date
                        )}
                      </p>
                    </td>
                    <td className={classes.paymentTableRow}>
                      <p>
                        <NumberFormat value={invoice.sum} />
                      </p>
                    </td>
                    <td className={classes.paymentTableRow}>
                      <p>
                        <NumberFormat value={invoice.vat} />
                      </p>
                    </td>
                    <td className={classes.paymentTableRow}>
                      <p>
                        <NumberFormat value={invoice.total_sum} />
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={classes.bankInfo}>
                <p style={{ flex: '0.7' }}>
                  {t(`${invoicePdfKey}.account_number`)} Nordea FI31 1745 3000
                  3174 63
                </p>
                <p>SWIFT / BIC: NDEAFIHH</p>
              </div>
              <div className={classes.virtualCode}>
                <p>
                  {t(`${invoicePdfKey}.virtual_bank_barcode`)}{' '}
                  <span style={{ color: 'gray' }}>XXXX</span>
                </p>
              </div>
            </div>

            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.receivers_account_number1`)}
                      <br />
                      {t(`${invoicePdfKey}.receivers_account_number2`)}
                      <br />
                      {t(`${invoicePdfKey}.receivers_account_number3`)}
                      <br />
                      {t(`${invoicePdfKey}.receivers_account_number4`)}
                      <br />
                      {t(`${invoicePdfKey}.receivers_account_number5`)}
                    </p>
                  </td>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.bankCodes}>IBAN</p>
                    <p>Nordea FI31 1745 3000 3174 63</p>
                  </td>
                  <td colSpan="5" className={classes.borderBottom}>
                    <p className={classes.bankCodes}>BIC</p>
                    <p>NDEAFIHH</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.receiver1`)}
                      <br />
                      {t(`${invoicePdfKey}.receiver2`)}
                    </p>
                  </td>
                  <td colSpan="3" className={classes.borderBox}>
                    <p>Invosy Oy</p>
                  </td>
                  <td></td>
                  <td colSpan="5"></td>
                </tr>
                <tr>
                  <td colSpan="2"></td>
                  <td></td>
                  <td colSpan="2"></td>
                  <td></td>
                  <td colSpan="4" rowSpan="2" className={classes.borderBottom}>
                    <p>{t(`${invoicePdfKey}.invoice_notice`)}</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.payers_info1`)}
                      <br />
                      {t(`${invoicePdfKey}.payers_info2`)}
                      <br />
                      {t(`${invoicePdfKey}.payers_info3`)}
                      <br />
                      {t(`${invoicePdfKey}.payers_info4`)}
                      <br />
                      {t(`${invoicePdfKey}.payers_info5`)}
                      <br />
                      {t(`${invoicePdfKey}.payers_info6`)}
                    </p>
                  </td>
                  <td colSpan="3" className={classes.borderBox}>
                    <span>{invoice.company_name}</span> <br />
                    <span>{invoice.delivery_address}</span>
                    <br />
                    <span>
                      {invoice.zip_code} {invoice.city}
                    </span>
                    <br />
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.signature1`)}
                      <br />
                      {t(`${invoicePdfKey}.signature2`)}
                    </p>
                  </td>
                  <td colSpan="3" className={classes.borderBox}></td>
                  <td className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.ref_number1`)} <br />
                      {t(`${invoicePdfKey}.ref_number2`)}
                    </p>
                  </td>
                  <td colSpan="2" className={classes.borderBox}>
                    <p style={{ color: 'gray' }}>XXXX</p>
                  </td>
                  <td className={classes.borderBottom}></td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan="3" className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.payment_account_1`)}
                      <br />
                      {t(`${invoicePdfKey}.payment_account_2`)}
                      <br />
                      {t(`${invoicePdfKey}.payment_account_3`)}
                    </p>
                  </td>
                  <td colSpan="3" className={classes.borderBox}></td>
                  <td className={classes.borderBox}>
                    <p className={classes.paymentInfo}>
                      {t(`${invoicePdfKey}.due_date1_a`)}
                      <br />
                      {t(`${invoicePdfKey}.due_date2_a`)}
                    </p>
                  </td>
                  <td colSpan="2" className={classes.borderBox}>
                    <p>
                      {new Intl.DateTimeFormat('fi-FI').format(
                        invoice.due_date
                      )}
                    </p>
                  </td>
                  <td className={classes.borderBottom}>
                    <p>
                      Euro
                      <span style={{ marginLeft: 10 }}>
                        <NumberFormat value={invoice.total_sum} />
                      </span>
                    </p>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className={classes.paymentTableInfo}>
              <p className={classes.barcodeText}>
                {t(`${invoicePdfKey}.barcode_text_1`)}
                <br />
                {t(`${invoicePdfKey}.barcode_text_2`)}
              </p>
            </div>
            <div className={classes.footer}>
              <p> Invosy.com/fi-{t(`${invoicePdfKey}.service_name`)}</p>
              <div style={{ textAlign: 'center' }}>
                <p>{t(`${invoicePdfKey}.business_id`)} 3413106-8 </p>
                <p>asiakaspalvelu@invosy.com</p>
              </div>
              <p style={{ textAlign: 'right' }}>
                Salomonkatu 17 B, 00100 HELSINKI
              </p>
            </div>
          </div>
        ) : (
          <p className={classes.body}>{t('invoice.invoiceNotFound')}</p>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(invoicePdf)
